import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import AddTask from "./addTask";
import AddContact from "./addContact";
import "./app.css";
import { secretKey } from "./data";
import Loading from "./loading.js";
import AddFile from "./addFile";
import AddLeadRecommendation from "./addLeadRecommendation";
import ShowNote from "./showNote";
import { faEdit, faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const MySwal = withReactContent(Swal2);

const LeadDetail = (props) => {
  const [loading, setLoading] = useState(true);
  const [option, setOption] = useState(0);
  const [lead, setLead] = useState(props.lead);
  const [tasks, setTasks] = useState([]);
  const [taskEdit, setTaskEdit] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [logs, setLogs] = useState([]);
  const [contactEdit, setContactEdit] = useState([]);
  const [files, setFiles] = useState([]);
  const [users, setUsers] = useState([]);
  const [showTaskEdit, setShowTaskEdit] = useState(false);
  const [showTaskAdd, setShowTaskAdd] = useState(false);
  const [showContactAdd, setShowContactAdd] = useState(false);
  const [showContactEdit, setShowContactEdit] = useState(false);
  const [showFileAdd, setShowFileAdd] = useState(false);
  const [showAddRecommendation, setShowAddRecommendation] = useState(false);
  const [showNote, setShowNote] = useState(false);
  const [noteMode, setNoteMode] = useState("note");

  const closeEditTask = () => {
    setShowTaskEdit(false);
    getData();
  };

  const closeAddRecommendation = () => {
    setShowAddRecommendation(false);
    getData();
  };

  const closeAddFile = () => {
    setShowFileAdd(false);
    getData();
  };

  const closeAddTask = () => {
    setShowTaskAdd(false);
    getData();
  };

  const closeEditContact = () => {
    setShowContactEdit(false);
    getData();
  };

  const closeAddContact = () => {
    setShowContactAdd(false);
    getData();
  };

  const fetchLeadData = async (id, field, value) => {
    var body = { id: props.lead.id };

    await fetch("https://apisplit.ftpeople.pl/getSingleLeadData", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setLead(data[0]);
        fetchLogs();
      })
      .catch((error) => {});
  };

  const fetchLogs = async (id, field, value) => {
    var body = { leadId: props.lead.id };

    await fetch("https://apisplit.ftpeople.pl/getLogs", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setLogs(data);
        fetchTasksData();
      })
      .catch((error) => {});
  };

  const fetchTasksData = async (id, field, value) => {
    var body = { id: props.lead.id };

    await fetch("https://apisplit.ftpeople.pl/getSingleLeadTasksData", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setTasks(data);
        fetchContactsData();
      })
      .catch((error) => {});
  };

  const fetchContactsData = async (id, field, value) => {
    var body = { id: props.lead.id };

    await fetch("https://apisplit.ftpeople.pl/getSingleLeadContactsData", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setContacts(data);
        fetchFilesData();
      })
      .catch((error) => {});
  };

  const fetchFilesData = async (id, field, value) => {
    var body = { id: props.lead.id };

    await fetch("https://apisplit.ftpeople.pl/getSingleLeadFilesData", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setFiles(data);
        fetchUsersList();
      })
      .catch((error) => {});
  };

  const fetchUsersList = async () => {
    var body = {};

    await fetch("https://apisplit.ftpeople.pl/getUsersListAll", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setUsers(data);
        fetchStatuses();
      })
      .catch((error) => {});
  };

  const fetchStatuses = async () => {
    var body = {};

    await fetch("https://apisplit.ftpeople.pl/getStatuses", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setStatuses(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchLeadData();
  };

  useEffect(() => {
    getData();
  }, []);

  const fetchEditLead = async (id, field, value) => {
    var body = { id: id, field: field, value: value };

    await fetch("https://apisplit.ftpeople.pl/editLead", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        getData();
      })
      .catch((error) => {});
  };

  const editLead = (e) => {
    var id = e.target.value;
    var field = e.target.id;
    var valueP = e.currentTarget.attributes.fieldValue.value;

    MySwal.fire({
      title: "Zmiana",
      input: "text",
      inputValue: valueP,
      inputLabel: "nowa wartość",
      cancelButtonText: "Anuluj",
      showCancelButton: true,
      inputValidator: (value) => {
        fetchEditLead(id, field, value);
        if (field === "name") {
          props.logAction(
            id,
            `Zmieniono nazwę leada z ${lead.name} na ${value} przez ${props.user.name}`
          );
        }
        if (field === "phone") {
          props.logAction(
            id,
            `Zmieniono numer telefonu leada z ${lead.phone} na ${value} przez ${props.user.name}`
          );
        }
        if (field === "mail") {
          props.logAction(
            id,
            `Zmieniono adres e-mail leada z ${lead.mail} na ${value} przez ${props.user.name}`
          );
        }
        if (field === "sourceNote") {
          props.logAction(
            id,
            `Zmieniono notatkę źródłową leada z ${lead.sourceNote} na ${value} przez ${props.user.name}`
          );
        }
        if (field === "sourceLink") {
          props.logAction(
            id,
            `Zmieniono link źródłowy leada z ${lead.sourceLink} na ${value} przez ${props.user.name}`
          );
        }
        if (field === "statusNote") {
          props.logAction(
            id,
            `Zmieniono notatkę leada z ${lead.statusNote} na ${value} przez ${props.user.name}`
          );
        }
      },
    });
  };

  const editLeadAggr = (e) => {
    var id = e.target.value;
    var field = e.target.id;

    var model = [];
    model["Tak"] = "Tak";
    model["Nie"] = "Nie";
    model["Niepełna"] = "Niepełna";
    model["Zanonimizowana"] = "Zanonimizowana";

    MySwal.fire({
      title: "Wybierz wartość",
      input: "select",
      inputOptions: model,
      inputPlaceholder: "wybierz wartość",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz wybrać wartość");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        fetchEditLead(id, field, result.value);
        props.logAction(
          id,
          `Zmieniono inormację o umowie leada z ${lead.aggr} na ${result.value} przez ${props.user.name}`
        );
      }
    });
  };

  const editLeadStatus = (e) => {
    var id = e.target.value;
    var field = e.target.id;

    var model = [];
    statuses.map((el) => {
      model[el.name] = el.name;
    });

    MySwal.fire({
      title: "Wybierz wartość",
      input: "select",
      inputOptions: model,
      inputPlaceholder: "wybierz wartość",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz wybrać wartość");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        fetchEditLead(id, field, result.value);
        props.logAction(
          id,
          `Zmieniono status leada z ${lead.status} na ${result.value} przez ${props.user.name}`
        );
      }
    });
  };

  const fetchDeleteFile = async (id) => {
    var body = { id: id };

    await fetch("https://apisplit.ftpeople.pl/deleteFile", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Plik",
          text: "usunięty",
        }).then(async (result) => {
          getData();
        });
      })
      .catch((error) => {});
  };

  const deleteFile = (e) => {
    fetchDeleteFile(e.target.value);
  };

  const showNoteBox = (e) => {
    e.preventDefault();
    setNoteMode("note");
    setShowNote(true);
  };

  const showNoteSourceBox = (e) => {
    e.preventDefault();
    setNoteMode("source");
    setShowNote(true);
  };

  const leadData = (
    <>
      <div style={{ marginTop: "5vh" }}>
        <table style={{ marginTop: "0vh" }} className="clients_table">
          <tr>
            <th style={{ width: "15%" }}>Pole</th>
            <th style={{ width: "50%", lineBreak: "anywhere" }}>Wartość</th>
            <th style={{ width: "15%" }}>Akcja</th>
          </tr>
          <tr>
            <td>ID</td>
            <td>{lead.id}</td>
            <td></td>
          </tr>
          <tr>
            <td>Nazwa</td>
            <td>{lead.name}</td>
            <td>
              <button
                className="loginButtonLogin"
                id={"name"}
                fieldValue={lead.name ? lead.name : ""}
                value={lead.id}
                style={{
                  margin: "0",
                  backgroundColor: "navy",
                  borderColor: "navy",
                  width: "45%",
                  fontSize: ".6vw",
                  padding: "5px 5px",
                }}
                onClick={editLead}
              >
                zmień
              </button>
            </td>
          </tr>
          <tr>
            <td>Numer telefonu</td>
            <td>{lead.phone}</td>
            <td>
              <button
                className="loginButtonLogin"
                id={"phone"}
                value={lead.id}
                fieldValue={lead.phone ? lead.phone : ""}
                style={{
                  margin: "0",
                  backgroundColor: "navy",
                  borderColor: "navy",
                  width: "45%",
                  fontSize: ".6vw",
                  padding: "5px 5px",
                }}
                onClick={editLead}
              >
                zmień
              </button>
            </td>
          </tr>
          <tr>
            <td>Adres e-mail</td>
            <td>{lead.mail}</td>
            <td>
              <button
                className="loginButtonLogin"
                id={"mail"}
                value={lead.id}
                fieldValue={lead.mail ? lead.mail : ""}
                style={{
                  margin: "0",
                  backgroundColor: "navy",
                  borderColor: "navy",
                  width: "45%",
                  fontSize: ".6vw",
                  padding: "5px 5px",
                }}
                onClick={editLead}
              >
                zmień
              </button>
            </td>
          </tr>
          <tr>
            <td>Źródło</td>
            <td>{lead.source}</td>
            <td></td>
          </tr>
          <tr>
            <td>ID źródło</td>
            <td>{lead.idSource ? lead.idSource : "brak danych"}</td>
            <td></td>
          </tr>
          <tr>
            <td>Dział</td>
            <td>{lead.company}</td>
            <td></td>
          </tr>
          <tr>
            <td>Data pozyskania</td>
            <td>{lead.date}</td>
            <td></td>
          </tr>
          <tr>
            <td>Notatka - źródło</td>
            <td style={{ width: "50%", lineBreak: "anywhere" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  padding: "0px 5px",
                }}
              >
                <div
                  style={{
                    width: "90%",
                  }}
                >
                  {lead.sourceNote}
                </div>
              </div>
            </td>
            <td>
              <button
                className="loginButtonLogin"
                id={"sourceNote"}
                value={lead.id}
                fieldValue={lead.sourceNote ? lead.sourceNote : ""}
                style={{
                  margin: "0",
                  backgroundColor: "navy",
                  borderColor: "navy",
                  width: "45%",
                  fontSize: ".6vw",
                  padding: "5px 5px",
                }}
                onClick={editLead}
              >
                zmień
              </button>
            </td>
          </tr>
          <tr>
            <td>Umowa</td>
            <td style={{ width: "50%", lineBreak: "anywhere" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  padding: "0px 5px",
                }}
              >
                <div
                  style={{
                    width: "90%",
                  }}
                >
                  {lead.aggr}
                </div>
              </div>
            </td>
            <td>
              <button
                className="loginButtonLogin"
                id={"aggr"}
                value={lead.id}
                fieldValue={lead.aggr ? lead.aggr : ""}
                style={{
                  margin: "0",
                  backgroundColor: "navy",
                  borderColor: "navy",
                  width: "45%",
                  fontSize: ".6vw",
                  padding: "5px 5px",
                }}
                onClick={editLeadAggr}
              >
                zmień
              </button>
            </td>
          </tr>
          <tr>
            <td>Link - źródło</td>
            <td style={{ width: "50%", lineBreak: "anywhere" }}>
              {lead.sourceLink ? (
                <>
                  <a href={lead.sourceLink} target="_blank">
                    link - źródło
                  </a>
                </>
              ) : (
                "brak linku"
              )}
            </td>
            <td>
              <button
                className="loginButtonLogin"
                id={"sourceLink"}
                value={lead.id}
                fieldValue={lead.sourceLink ? lead.sourceLink : ""}
                style={{
                  margin: "0",
                  backgroundColor: "navy",
                  borderColor: "navy",
                  width: "45%",
                  fontSize: ".6vw",
                  padding: "5px 5px",
                }}
                onClick={editLead}
              >
                zmień
              </button>
            </td>
          </tr>
          <tr>
            <td>Status</td>
            <td>{lead.status}</td>
            <td>
              <button
                className="loginButtonLogin"
                id={"status"}
                value={lead.id}
                style={{
                  margin: "0",
                  backgroundColor: "navy",
                  borderColor: "navy",
                  width: "45%",
                  fontSize: ".6vw",
                  padding: "5px 5px",
                }}
                onClick={editLeadStatus}
              >
                zmień
              </button>
            </td>
          </tr>
          <tr>
            <td>Status - notatka</td>
            <td>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  padding: "0px 5px",
                }}
              >
                <div
                  style={{
                    width: "90%",
                  }}
                >
                  {lead.statusNote}
                </div>
              </div>
            </td>
            <td>
              <button
                className="loginButtonLogin"
                id={"statusNote"}
                value={lead.id}
                fieldValue={lead.statusNote ? lead.statusNote : ""}
                style={{
                  margin: "0",
                  backgroundColor: "navy",
                  borderColor: "navy",
                  width: "45%",
                  fontSize: ".6vw",
                  padding: "5px 5px",
                }}
                onClick={editLead}
              >
                zmień
              </button>
            </td>
          </tr>
        </table>
      </div>
    </>
  );

  const handleEditTask = (e) => {
    setTaskEdit(tasks.filter((el) => +el.id === +e.target.value)[0]);
    setShowTaskEdit(true);
  };

  const tasksData = (
    <>
      <div style={{ marginTop: "5vh" }}>
        {tasks.length === 0 ? (
          <>Brak zadań dla tego kontatku</>
        ) : (
          <>
            <table style={{ marginTop: "0vh" }} className="clients_table">
              <tr key={0}>
                <th style={{ width: "10%" }}>id</th>
                <th style={{ width: "50%" }}>zadanie</th>
                <th style={{ width: "10%" }}>data</th>
                <th style={{ width: "10%" }}>status</th>
                <th style={{ width: "10%" }}>użytkownik</th>
                <th style={{ width: "10%" }}>akcja</th>
              </tr>
              {tasks
                .sort(function (a, b) {
                  return new Date(b.date) - new Date(a.date);
                })
                .map((el, index) => (
                  <>
                    <tr>
                      <td
                        style={{
                          backgroundColor:
                            el.status === "WYKONANE" ? "green" : "transparent",
                          color: el.status === "WYKONANE" ? "white" : "black",
                        }}
                      >
                        {el.id}
                      </td>
                      <td>{el.task}</td>
                      <td>{el.date}</td>
                      <td>{el.status}</td>
                      <td>
                        {users.length === 0
                          ? ""
                          : users.filter((user) => +user.id === +el.user)[0]
                              .name}
                      </td>
                      <td>
                        <button
                          className="loginButtonLogin"
                          id={"statusNote"}
                          value={el.id}
                          style={{
                            margin: "0",
                            backgroundColor: "navy",
                            borderColor: "navy",
                            width: "45%",
                            fontSize: ".6vw",
                            padding: "5px 5px",
                          }}
                          onClick={handleEditTask}
                        >
                          zobacz
                        </button>
                      </td>
                    </tr>
                  </>
                ))}
            </table>
          </>
        )}
      </div>
    </>
  );

  const logsData = (
    <>
      <div style={{ marginTop: "5vh" }}>
        {logs.length === 0 ? (
          <>Brak logów dla tego kontatku</>
        ) : (
          <>
            <table style={{ marginTop: "0vh" }} className="clients_table">
              <tr key={0}>
                <th style={{ width: "10%" }}>id</th>
                <th style={{ width: "50%" }}>treść</th>
                <th style={{ width: "10%" }}>data</th>
              </tr>
              {logs
                .sort(function (a, b) {
                  return new Date(b.date) - new Date(a.date);
                })
                .map((el, index) => (
                  <>
                    <tr>
                      <td
                        style={{
                          backgroundColor:
                            el.status === "WYKONANE" ? "green" : "transparent",
                          color: el.status === "WYKONANE" ? "white" : "black",
                        }}
                      >
                        {el.id}
                      </td>
                      <td style={{ textAlign: "left" }}>{el.content}</td>
                      <td>{el.date}</td>
                    </tr>
                  </>
                ))}
            </table>
          </>
        )}
      </div>
    </>
  );

  const handleEditContact = (e) => {
    setContactEdit(contacts.filter((el) => +el.id === +e.target.value)[0]);
    setShowContactEdit(true);
  };

  const contactsData = (
    <>
      <div style={{ marginTop: "5vh" }}>
        {contacts.length === 0 ? (
          <>Brak notatek dla tego kontatku</>
        ) : (
          <>
            <table style={{ marginTop: "0vh" }} className="clients_table">
              <tr key={0}>
                <th style={{ width: "10%" }}>id</th>
                <th style={{ width: "10%" }}>data</th>
                <th style={{ width: "60%" }}>treść</th>
                <th style={{ width: "10%" }}>użytkownik</th>
                <th style={{ width: "10%" }}>akcja</th>
              </tr>
              {contacts
                .sort(function (a, b) {
                  return new Date(b.date) - new Date(a.date);
                })
                .map((el, index) => (
                  <>
                    <tr>
                      <td
                        style={{
                          backgroundColor:
                            el.status === "WYKONANE" ? "green" : "transparent",
                          color: el.status === "WYKONANE" ? "white" : "black",
                        }}
                      >
                        {el.id}
                      </td>
                      <td>{el.date}</td>
                      <td>{el.content}</td>
                      <td>
                        {users.length === 0
                          ? ""
                          : users.filter((user) => +user.id === +el.user)[0]
                              .name}
                      </td>
                      <td>
                        <button
                          className="loginButtonLogin"
                          id={"statusNote"}
                          value={el.id}
                          style={{
                            margin: "0",
                            backgroundColor: "navy",
                            borderColor: "navy",
                            width: "45%",
                            fontSize: ".6vw",
                            padding: "5px 5px",
                          }}
                          onClick={handleEditContact}
                        >
                          zobacz
                        </button>
                      </td>
                    </tr>
                  </>
                ))}
            </table>
          </>
        )}
      </div>
    </>
  );

  const download = async (url, filename) => {
    const data = await fetch(url);
    const blob = await data.blob();
    const objectUrl = URL.createObjectURL(blob);

    const link = document.createElement("a");

    link.setAttribute("href", objectUrl);
    link.setAttribute("download", filename);
    link.style.display = "none";

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  };

  const downloadFile = (e) => {
    var file = files.filter((el) => el.id === +e.target.value)[0];

    download(file.link, file.name);
  };

  const filesData = (
    <>
      <div style={{ marginTop: "5vh" }}>
        {files.length === 0 ? (
          <>Brak plików dla tego kontatku</>
        ) : (
          <>
            <table style={{ marginTop: "0vh" }} className="clients_table">
              <tr key={0}>
                <th style={{ width: "10%" }}>id</th>
                <th style={{ width: "65%" }}>nazwa</th>
                <th style={{ width: "10%" }}>użytkownik</th>
                <th style={{ width: "15%" }}>akcja</th>
              </tr>
              {files
                .sort(function (a, b) {
                  return new Date(b.date) - new Date(a.date);
                })
                .map((el, index) => (
                  <>
                    <tr>
                      <td>{el.id}</td>
                      <td>{el.name}</td>
                      <td>
                        {users.length === 0
                          ? ""
                          : users.filter((user) => +user.id === +el.user)[0]
                              .name}
                      </td>
                      <td>
                        <button
                          className="loginButtonLogin"
                          id={"statusNote"}
                          value={el.id}
                          style={{
                            margin: "0",
                            backgroundColor: "navy",
                            borderColor: "navy",
                            width: "45%",
                            fontSize: ".6vw",
                            padding: "5px 5px",
                          }}
                          onClick={downloadFile}
                        >
                          pobierz
                        </button>
                        <button
                          className="loginButtonLogin"
                          id={"statusNote"}
                          value={el.id}
                          style={{
                            margin: "0",
                            backgroundColor: "navy",
                            borderColor: "navy",
                            width: "45%",
                            fontSize: ".6vw",
                            padding: "5px 5px",
                            marginLeft: "10px",
                          }}
                          onClick={deleteFile}
                        >
                          usuń
                        </button>
                      </td>
                    </tr>
                  </>
                ))}
            </table>
          </>
        )}
      </div>
    </>
  );

  return (
    <>
      <div
        style={{
          position: "fixed",
          top: "10vh",
          height: "80vh",
          backgroundColor: "white",
          width: "80vw",
          boxShadow: "-8px 0px 24px 0px rgba(66, 68, 90, 1)",
          borderRadius: "15px",
          zIndex: 2,
          overflowY: "scroll",
          paddingBottom: "20px",
        }}
      >
        {loading ? (
          <Loading />
        ) : (
          <>
            {showNote ? (
              <>
                <ShowNote
                  close={() => {
                    setShowNote(false);
                  }}
                  lead={lead}
                  mode={noteMode}
                />
              </>
            ) : (
              ""
            )}
            {showAddRecommendation ? (
              <>
                <AddLeadRecommendation
                  lead={props.lead}
                  user={props.user}
                  close={closeAddRecommendation}
                />
              </>
            ) : (
              ""
            )}
            {showFileAdd ? (
              <>
                <AddFile
                  lead={props.lead}
                  user={props.user}
                  close={closeAddFile}
                />
              </>
            ) : (
              ""
            )}
            {showTaskEdit ? (
              <>
                <AddTask
                  mode={"edit"}
                  task={taskEdit}
                  user={props.user}
                  close={closeEditTask}
                />
              </>
            ) : (
              ""
            )}
            {showTaskAdd ? (
              <>
                <AddTask
                  mode={"add"}
                  task={""}
                  user={props.user}
                  close={closeAddTask}
                  lead={props.lead}
                />
              </>
            ) : (
              ""
            )}
            {showContactEdit ? (
              <>
                <AddContact
                  mode={"edit"}
                  contact={contactEdit}
                  user={props.user}
                  close={closeEditContact}
                />
              </>
            ) : (
              ""
            )}
            {showContactAdd ? (
              <>
                <AddContact
                  mode={"add"}
                  contact={""}
                  user={props.user}
                  close={closeAddContact}
                  lead={props.lead}
                />
              </>
            ) : (
              ""
            )}

            <div
              style={{
                paddingBottom: "3vh",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "left",
                  gap: "1vw",
                  alignItems: "self-end",

                  flexWrap: "wrap",
                  zIndex: "1",

                  padding: "1vw",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    marginBottom: "3vh",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      width: "85%",
                      textAlign: "left",
                      fontWeight: "600",
                      fontSize: "2vw",
                    }}
                  >
                    {lead.name}
                  </div>
                  <div style={{ width: "15%" }}>
                    <button
                      className="loginButtonLogin"
                      value="yes"
                      style={{
                        margin: "0",
                        backgroundColor: "navy",
                        borderColor: "navy",
                        width: "100%",
                      }}
                      onClick={props.close}
                    >
                      X
                    </button>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    gap: "1vw",
                    width: "100%",
                  }}
                >
                  <button
                    className="loginButtonLogin"
                    value="yes"
                    style={{ margin: "0", width: "20%" }}
                    onClick={() => setOption(0)}
                  >
                    DANE KONTAKTU
                  </button>
                  <button
                    className="loginButtonLogin"
                    value="yes"
                    style={{
                      margin: "0",
                      width: "20%",
                      backgroundColor: "red",
                    }}
                    onClick={() => setOption(4)}
                  >
                    LOGI
                  </button>
                  <button
                    className="loginButtonLogin"
                    value="yes"
                    style={{
                      margin: "0",
                      width: "20%",
                      backgroundColor: "green",
                      borderColor: "green",
                    }}
                    onClick={() => setOption(1)}
                  >
                    ZADANIA
                  </button>
                  <button
                    className="loginButtonLogin"
                    value="yes"
                    style={{
                      margin: "0",
                      width: "20%",
                      backgroundColor: "navy",
                      borderColor: "navy",
                    }}
                    onClick={() => setOption(2)}
                  >
                    KONTAKTY
                  </button>
                  <button
                    className="loginButtonLogin"
                    value="yes"
                    style={{
                      margin: "0",
                      width: "20%",
                      backgroundColor: "gray",
                      borderColor: "gray",
                    }}
                    onClick={() => setOption(3)}
                  >
                    PLIKI
                  </button>
                </div>
                <hr
                  style={{
                    borderWidth: "1px",
                    borderColor: "lightgray",
                    opacity: ".3",
                    backgroundColor: "lightgray",
                    zIndex: "-1",
                    position: "relative",
                    width: "100%",
                  }}
                />
                <div
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    gap: "1vw",
                    marginTop: "1vh",
                    width: "100%",
                  }}
                >
                  <button
                    className="loginButtonLogin"
                    value="yes"
                    style={{
                      margin: "0",
                      width: "20%",
                      backgroundColor: "lightgray",
                      borderColor: "lightgray",
                      color: "gray",
                    }}
                    onClick={() => setShowTaskAdd(true)}
                  >
                    DODAJ ZADANIE
                  </button>
                  <button
                    className="loginButtonLogin"
                    value="yes"
                    style={{
                      margin: "0",
                      width: "20%",
                      backgroundColor: "lightgray",
                      borderColor: "lightgray",
                      color: "gray",
                    }}
                    onClick={() => setShowContactAdd(true)}
                  >
                    DODAJ KONTAKT
                  </button>
                  <button
                    className="loginButtonLogin"
                    value="yes"
                    style={{
                      margin: "0",
                      width: "20%",
                      backgroundColor: "lightgray",
                      borderColor: "lightgray",
                      color: "gray",
                    }}
                    onClick={() => setShowFileAdd(true)}
                  >
                    DODAJ PLIK
                  </button>
                  {true ? (
                    <button
                      className="loginButtonLogin"
                      value="yes"
                      style={{
                        margin: "0",
                        width: "20%",
                        backgroundColor: "lightgray",
                        borderColor: "lightgray",
                        color: "gray",
                      }}
                      onClick={() => setShowAddRecommendation(true)}
                    >
                      DODAJ LEAD
                    </button>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div style={{ padding: "1vw" }}>
                {+option === 0 ? <>{leadData}</> : ""}
                {+option === 4 ? <>{logsData}</> : ""}
                {+option === 1 ? <>{tasksData}</> : ""}
                {+option === 2 ? <>{contactsData}</> : ""}
                {+option === 3 ? <>{filesData}</> : ""}
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default LeadDetail;
